module.exports = __webpack_public_path__ + "img/flappy-bird-full-website-2.fc98029e.png";